/**
 * Breadcrumb navigation store.
 *
 * Page components set their breadcrumbs on mount.
 * PageHeader reads from this store to render navigation.
 */

import { useLayoutEffect } from "react";
import { create } from "zustand";

export interface Breadcrumb {
  label: string;
  /** Path to navigate to. If omitted, crumb is not clickable (current page). */
  path?: string;
}

interface BreadcrumbState {
  breadcrumbs: Breadcrumb[];
  setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  breadcrumbs: [],
  setBreadcrumbs: (breadcrumbs) => set({ breadcrumbs }),
}));

export function useBreadcrumbs(breadcrumbs: Breadcrumb[]) {
  const setBreadcrumbs = useBreadcrumbStore((s) => s.setBreadcrumbs);

  useLayoutEffect(() => {
    setBreadcrumbs(breadcrumbs);
    return () => setBreadcrumbs([]);
  }, [breadcrumbs, setBreadcrumbs]);
}
